import Icon from '../../../components/AppIcon';

const TrustBadge = ({ icon, text }) => {
  return (
    <div className="flex items-center gap-2 px-4 py-2 rounded-lg bg-success/10 border border-success/20">
      <Icon name={icon} size={16} color="var(--color-success)" />
      <span className="text-sm font-medium text-success">{text}</span>
    </div>
  );
};

export default TrustBadge;